import axios from 'axios'
import { Error } from './Error'

const timeout: number = 30000

export default class Image {
  request(token, method, uri, cached) {
    const base = cached ? process.env.VUE_APP_API_IMAGE_CACHED_URL : process.env.VUE_APP_API_IMAGE_URL
    const url = `${base}/${uri}`
    const headers = this.headers(token)
    return axios({ headers, method, timeout, url })
  }

  headers(token) {
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
    return token ? { ...headers, Authorization: token } : headers
  }

  async getImage(token, id) {
    try {
      return await this.request(token, 'get', `cache/${id}`, true)
    } catch (error) {
      throw new Error(error)
    }
  }

  async getImageFromHash(token, hash, thumb = false ) {
    try {
      const proovCode = hash.split('/')[1]
      const name = hash.split('/')[2]
      const nameWithExtension = name.split('.')[0]
      const extension = name.split('.')[1]
      const size = thumb ? 'thumb' : 'normalized'

      const path = `picture?pc=${proovCode}&name=${nameWithExtension}/${size}.${extension}`

      return await this.request(token, 'get', path, true)
    } catch (error) {
      throw new Error(error)
    }
  }
}
